import type { FC } from "react";
import { useMemo } from "react";
import type { Control } from "react-hook-form";
import { RentBasedAmountSection } from "web_myplann/Goals/Components/AmountSections/RentBasedAmountSection";
import { SavingsAmountSection } from "web_myplann/Goals/Components/AmountSections/SavingsAmountSection";
import { WithLoanAmountSection } from "web_myplann/Goals/Components/AmountSections/WithLoanAmountSection";
import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	control: Control<GoalFormModel>;
	category: GoalCategoryTypeEnum | undefined;
};

type AmountSectionComponentProps = {
	control: Control<GoalFormModel>;
	category: GoalCategoryTypeEnum;
};

const CATEGORY_COMPONENT_MAP: Record<
	GoalCategoryTypeEnum,
	FC<AmountSectionComponentProps>
> = {
	[GoalCategoryTypeEnum.Pension]: RentBasedAmountSection,
	[GoalCategoryTypeEnum.Rent]: RentBasedAmountSection,
	[GoalCategoryTypeEnum.Student]: SavingsAmountSection,
	[GoalCategoryTypeEnum.Vacation]: SavingsAmountSection,
	[GoalCategoryTypeEnum.Basic]: WithLoanAmountSection,
	[GoalCategoryTypeEnum.Car]: WithLoanAmountSection,
	[GoalCategoryTypeEnum.House]: WithLoanAmountSection,
};

export const GoalAmountSection: React.FC<Props> = ({ control, category }) => {
	const Component = useMemo(
		() => (category ? CATEGORY_COMPONENT_MAP[category] : null),
		[category],
	);

	if (!Component || !category) return null;

	return <Component control={control} category={category} />;
};
